query simpleBaseballTeams($search: String) {
  teams: allBaseballTeams(
    orderBy: NAME_ASC
    first: 20
    filter: { name: { includesInsensitive: $search } }
  ) {
    nodes {
      id: teamId
      name
    }
  }
}
